/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailShoulderToHem_item = {|
  +measurement: ?{|
    +shoulderToHem: ?$ReadOnlyArray<?{| |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShoulderToHem_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "shoulderToHem",
          "args": [
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "shoulderToHem"
              ],
              "type": "[measurementFieldType]"
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "name": "display",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailMeasurement_measurements",
              "args": null
            }
          ],
          "storageKey": "display{\"fields\":[\"shoulderToHem\"]}"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
